import { render, staticRenderFns } from "./ItemSelectionCard.vue?vue&type=template&id=1c422512&scoped=true"
import script from "./ItemSelectionCard.vue?vue&type=script&lang=js"
export * from "./ItemSelectionCard.vue?vue&type=script&lang=js"
import style0 from "./ItemSelectionCard.vue?vue&type=style&index=0&id=1c422512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c422512",
  null
  
)

export default component.exports